import AnalyticsWebClient from '@atlassiansox/analytics-web-client/client';
import { originType } from '@atlassiansox/analytics-web-client/analytics-web-types';

import { getConfig } from '../../config';

const product = 'teamworkGraph';
const subproduct = 'dtac';

const getIdentityEnv = (env: string): 'dev' | 'staging' | 'prod' => {
	switch (env) {
		case 'production':
			return 'prod';
		case 'staging':
			return 'staging';
		case 'development':
		case 'local':
		default:
			return 'dev';
	}
};

const getGasApiHost = (env: ReturnType<typeof getConfig>['env']): string => {
	switch (env) {
		case 'production':
			return `${window.location.host}/gateway/api/gasv3/api/v1`;
		case 'staging':
		case 'development':
		case 'local':
		default:
			return 'team.stg.atlassian.com/gateway/api/gasv3/api/v1';
	}
};

export const initAnalyticsClient = (): AnalyticsWebClient => {
	const { env, isLocalDev } = getConfig();

	return new AnalyticsWebClient(
		{
			env: getIdentityEnv(env),
			origin: originType.WEB,
			product,
			subproduct,
		},
		{
			apiHost: getGasApiHost(env),
			apiHostProtocol: isLocalDev ? 'http' : 'https', // We sometimes develop on local and emulate PROD
			disableCookiePersistence: true,
		},
	);
};
